module.exports = __webpack_public_path__ + "img/ab-tests-empty-list-dark.41bbae2f.svg";